import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface EmployeesAttendanceState {
  data: any;
  summary: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "get" | "update" | null;
}

const employeesAttendanceInitialState: EmployeesAttendanceState = {
  data: null,
  summary: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getEmployeesAttendance: any = createAsyncThunk(
  "get/employees-attendance",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ATTENDANCE.SUMMARY, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getAttendanceDocument: any = createAsyncThunk(
  "get/employees-attendance-doc",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.GET_ATTENDANCE_DOC_URL,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const employeesAttendanceUpdate: any = createAsyncThunk(
  "update/employees-attendance",
  async (payload: any, thunkAPI) => {
    try {
      console.log(payload, 'payload')
      const response = await Api.post(
        API_URLS.EMPLOYEES.UPDATE_ATTENDANCE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const bulkUpdateAttendance: any = createAsyncThunk(
  "update/bulk-employees-attendance",
  async (payload: any, thunkAPI) => {
    try {
      console.log(payload, "bulkUpdateAttendance payload");
      const response = await Api.post(
        API_URLS.EMPLOYEES.BULK_UPDATE_ATTENDANCE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getAttendanceSummary: any = createAsyncThunk(
  "fetch/attendance-summary",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ATTENDANCE.MY_ATTENDANCE_SUMMARY, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const employeesAttendanceSlice = createSlice({
  name: "reset",
  initialState: employeesAttendanceInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getEmployeesAttendance.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesAttendance.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesAttendance.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

    builder.addCase(getAttendanceDocument.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "get";
    });
    builder.addCase(getAttendanceDocument.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "get";
    });
    builder.addCase(getAttendanceDocument.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "get";
    });

    builder.addCase(employeesAttendanceUpdate.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(employeesAttendanceUpdate.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(employeesAttendanceUpdate.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });

    builder.addCase(bulkUpdateAttendance.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(bulkUpdateAttendance.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(bulkUpdateAttendance.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });

    builder.addCase(getAttendanceSummary.pending, (state) => {
      state.loading = "pending";
      state.summary = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getAttendanceSummary.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.summary = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getAttendanceSummary.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.summary = null;
      state.action = "list";
    });
  },
});

export const { resetAll } = employeesAttendanceSlice.actions;
export default employeesAttendanceSlice.reducer;
